import { call, put, takeLatest } from "redux-saga/effects";
import { ActionWithPayload } from "@shared/interfaces";
import { startLoading, stopLoading } from "@shared/store/actions";
import { downLoadFile } from "@shared/utils";

import api from "../api";
import {
  getSessionsReport,
  getSensorsDataReport,
  getDetailedSensorsDataReport,
  getDetailedUnfilteredSensorsDataReport,
} from "./actions";
import {
  GetSessionsReportPayload,
  GetReportResponse,
  GetFormsReportPayload,
  GetDetailedSensorsDataReportPayload,
  GetDetailedUnfilteredSensorsDataReportPayload,
} from "../interfaces";

function* sessionsReportSaga({ payload }: ActionWithPayload<GetSessionsReportPayload>) {
  try {
    yield put(startLoading());
    const response: GetReportResponse = yield call(api.sessionsReports, payload);

    yield put(stopLoading());
    downLoadFile(response.csv, "application/csv", response.file_name || "All");
    yield put(getSessionsReport.success(response));
  } catch (error) {
    yield put(getSessionsReport.failure(error as Error));
    yield put(stopLoading());
  }
}

function* sensorsDataReportSaga({ payload }: ActionWithPayload<GetFormsReportPayload>) {
  try {
    yield put(startLoading());
    const response: GetReportResponse = yield call(api.sensorsDataReports, payload);

    yield put(stopLoading());
    downLoadFile(response.csv, "application/csv", response.file_name || "All");
    yield put(getSensorsDataReport.success(response));
  } catch (error) {
    yield put(getSensorsDataReport.failure(error as Error));
    yield put(stopLoading());
  }
}

function* sensorsDetailedDataReportSaga({ payload }: ActionWithPayload<GetDetailedSensorsDataReportPayload>) {
  try {
    yield put(startLoading());
    const response: string = yield call(api.sensorsDetailedDataReports, payload);

    yield put(stopLoading());

    downLoadFile(response, "text/csv", `detailed_patient_data.csv`);

    yield put(getDetailedSensorsDataReport.success(response));
  } catch (error) {
    yield put(getDetailedSensorsDataReport.failure(error as Error));
    yield put(stopLoading());
  }
}

function* sensorsDetailedUnfilteredDataReportSaga({
  payload,
}: ActionWithPayload<GetDetailedUnfilteredSensorsDataReportPayload>) {
  try {
    yield put(startLoading());
    const response: string = yield call(api.sensorsDetailedUnfilteredDataReports, payload);

    yield put(stopLoading());

    downLoadFile(response, "text/csv", `detailed_unfiltered_patient_data.csv`);

    yield put(getDetailedUnfilteredSensorsDataReport.success(response));
  } catch (error) {
    yield put(getDetailedUnfilteredSensorsDataReport.failure(error as Error));
    yield put(stopLoading());
  }
}

function* reportSagas() {
  yield takeLatest(getSessionsReport.request, sessionsReportSaga);
  yield takeLatest(getSensorsDataReport.request, sensorsDataReportSaga);
  yield takeLatest(getDetailedSensorsDataReport.request, sensorsDetailedDataReportSaga);
  yield takeLatest(getDetailedUnfilteredSensorsDataReport.request, sensorsDetailedUnfilteredDataReportSaga);
}

export default reportSagas;
